// components/chapter/redux/chapterThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../../config"; // ✅ adjust path if config is elsewhere

export const fetchClassesThunk = createAsyncThunk(
  "chapter/fetchClasses",
  async () => {
    const res = await fetch(`${API_BASE_URL}/classes`);
    if (!res.ok) throw new Error("Failed to fetch classes");
    return await res.json();
  }
);

export const fetchSubjectsByClassThunk = createAsyncThunk(
  "chapter/fetchSubjects",
  async (classId) => {
    const res = await fetch(`${API_BASE_URL}/subjects/link/${classId}`);
    if (!res.ok) throw new Error("Failed to fetch subjects");
    return await res.json();
  }
);
export const fetchSectionsBySubjectThunk = createAsyncThunk(
  "chapter/fetchSections",
  async ({subjectId}) => { 
    const res = await fetch(`${API_BASE_URL}/subjects/section-link/${subjectId}`);
    if (!res.ok) throw new Error("Failed to fetch section");
    return await res.json();
  }
);

export const fetchChaptersThunk = createAsyncThunk(
  "chapter/fetchChapters",
  async ({ classId, subjectId }) => {
    const res = await fetch(`${API_BASE_URL}/chapters?subject_id=${subjectId}&class_id=${classId}`);
    if (!res.ok) throw new Error("Failed to fetch chapters");
    return await res.json();
  }
);

export const createChapterThunk = createAsyncThunk(
  "chapter/createChapter",
  async (payload) => {
    const res = await fetch(`${API_BASE_URL}/chapters`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to create chapter");
    return await res.json();
  }
);

export const updateChapterThunk = createAsyncThunk(
  "chapter/updateChapter",
  async ({ chapterId, payload }) => {
    const res = await fetch(`${API_BASE_URL}/chapters/${chapterId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to update chapter");
    return await res.json();
  }
);

export const deleteChapterThunk = createAsyncThunk(
  "chapter/deleteChapter",
  async (chapterId) => {
    const res = await fetch(`${API_BASE_URL}/chapters/${chapterId}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to delete chapter");
    return chapterId;
  }
);


